/**
 * Per-agent TDS helpers. Default is 0% (off).
 * Dashboard remittance should show a TDS line only when TDS applies
 * to the current user (or, for admin roles, when aggregated TDS exists).
 */

export function userHasTds(user) {
  return Number(user?.tds_pct || 0) > 0;
}

export function shouldShowDashboardTds(user, tdsAmount) {
  const amount = Number(tdsAmount || 0);
  if (!(amount > 0)) return false;
  const role = user?.role_name || user?.role;
  if (role === 'Agent' && user && user.tds_pct != null && user.tds_pct !== '') {
    return userHasTds(user);
  }
  return true;
}
